<template>
  <div>
    <div class="page-title-box">
      <div class="page-title">Applicant Detail</div>
      <div class="page-title-right">
        <el-button type="warning" :class="{'checkedPrimary':loading}" :disabled="loading" v-if="applicationIndex != 0"  @click="onPrevious"
            >Previous</el-button
          >
        <el-button type="warning" :class="{'checkedPrimary':loading}" :disabled="loading" v-if="applicationIndex != application.length -1 "  @click="onNext"
            >Next</el-button
          >
      </div>
    </div>
    
    <div class="page-box page-row">
      <el-row type="flex" align="top" justify="space-between">
        <el-col>
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="Status">
              <el-select v-model="applicationDetail.status" placeholder="">
                <el-option
                  v-for="(item, index) in applicationStatus"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                  >{{ item.label }}</el-option
                >
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                type="warning"
                @click="onSave(applicationDetail.status, 3)"
                >Save</el-button
              >
            </el-form-item>
          </el-form>
        </el-col>
        <el-col>
          <el-button type="warning" @click="onNeedCorrection"
            >Need Correction</el-button
          >
          <el-button
            type="warning"
             :class="{ checkedPrimary:
            (applicationDetail.status !== 2 && applicationDetail.status !== 3) }"
            :disabled="
              applicationDetail.status !== 2 && applicationDetail.status !== 3
            "
            @click="onConfirmApplication"
            >Confirm Applicant</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div class="page-box page-row">
      <el-tabs v-model="activeName">
        <el-tab-pane name="first">
          <span slot="label"
            >Applicant Detail
            <i
              v-if="getConfirmApplicationHistories(0)"
              class="el-icon-check"
            ></i>
          </span>
        </el-tab-pane>
        <el-tab-pane name="second">
          <span slot="label"
            >Supporting Document
            <i
              v-if="getConfirmApplicationHistories(1)"
              class="el-icon-check"
            ></i>
          </span>
        </el-tab-pane>
        <el-tab-pane name="third">
          <span slot="label"
            >Payment Detail
            <i
              v-if="getConfirmApplicationHistories(2)"
              class="el-icon-check"
            ></i>
          </span>
        </el-tab-pane>
        <el-tab-pane name="fourth" v-if="isMsType()">
          <span slot="label"
            >Other Question
            <i
              v-if="getConfirmApplicationHistories(3)"
              class="el-icon-check"
            ></i>
          </span>
        </el-tab-pane>
        <el-tab-pane name="five" v-if="isMsType()">
          <span slot="label"
            >Subject Applied
            <i
              v-if="getConfirmApplicationHistories(4)"
              class="el-icon-check"
            ></i>
          </span>
        </el-tab-pane>
        <el-tab-pane name="six">
          <span slot="label"
            >Status History
          </span>
        </el-tab-pane>
      </el-tabs>
      <applicantDetails
        :id="id"
        :type="type"
        :formLabelAlign="applicationDetail"
        v-show="activeName == 'first'"
      ></applicantDetails>
      <supportingDocument
        :type="type"
        :formLabelAlign="applicationDetail"
        v-show="activeName == 'second'"
      ></supportingDocument>
      <paymentDetail
        :formLabelAlign="applicationDetail"
        :id="id"
        v-show="activeName == 'third'"
      ></paymentDetail>
      <otherQuestion
        :formLabelAlign="applicationDetail"
        v-show="activeName == 'fourth'"
      ></otherQuestion>
      <subjectApplied
        :formType="type"
        :formLabelAlign="applicationDetail"
        v-show="activeName == 'five'"
      ></subjectApplied>
      <statusHistory
        :tableData="applicationDetail.statusHistories"
        v-show="activeName == 'six'"
      ></statusHistory>
      <div class="page-box-button" v-if="activeName !== 'six'">
        <el-button
          :class="{ checkedPrimary: isOperationType() ||
            (applicationDetail.status !== 2 && applicationDetail.status !== 3) }"
          class="page-warning-button wordWrap"
          :disabled="
            isOperationType() ||
            (applicationDetail.status !== 2 && applicationDetail.status !== 3)
          "
          type="warning"
          @click="onConfirmApplicationDetail"
          >Confirm Applicant Detail</el-button
        >
      </div>
    </div>
    <loadingSlotDialog :centerDialogVisible="confirmCenterDialogVisible">
      <img src="@/assets/images/feather-alert-circle.png" />
      <div class="dialog-text">Confirm the application</div>
      <div class="dialog-d" style="word-break: break-word">
        Are you sure to confirm the application? Once you confirm the
        application, the applicant will receive the announcement and email
        preset in the template.
      </div>
      <el-button @click="onConfirm" type="warning">Submit</el-button>
      <el-button @click="onCancel">Cancel</el-button>
    </loadingSlotDialog>
    <loadingSlotDialog
      @close="close"
      :centerDialogVisible="needCorrectionCenterDialogVisible"
    >
      <div class="dialog-text">Need correct the form information</div>
      <el-checkbox-group v-model="checkList">
        <el-checkbox
          v-for="(item, index) in needCorrections"
          :key="index"
          :label="item"
        ></el-checkbox>
      </el-checkbox-group>
      <div class="input-text-others">- 其他 Others</div>
      <el-input v-model="text" placeholder="Input Contents"></el-input>
      <el-button @click="onConfirmNeed" :loading="loadingDialog" type="warning"
        >Send</el-button
      >
      <el-button @click="onCancelNeed">Cancel</el-button>
    </loadingSlotDialog>
    <loadingDialog :centerDialogVisible="loadingDialog"></loadingDialog>
  </div>
</template>

<script>
import subjectApplied from "./components/subjectApplied.vue";
import loadingDialog from "@/components/loadingDialog";
import loadingSlotDialog from "@/components/loadingSlotDialog";
import applicantDetails from "./components/applicantDetail.vue";
import supportingDocument from "./components/supportingDocument.vue";
import statusHistory from "./components/statusHistory.vue";
import paymentDetail from "./components/paymentDetail.vue";
import otherQuestion from "./components/otherQuestion.vue";
import {
  getApplicationDetail,
  getApplication,
  confirmRequest,
  addBatchChangeApplicationFormsStatus,
  addRequestsFromApplications,
} from "@/api/admin/application";
export default {
  components: {
    subjectApplied,
    otherQuestion,
    statusHistory,
    loadingDialog,
    loadingSlotDialog,
    paymentDetail,
    applicantDetails,
    supportingDocument,
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading:true,
      isConfirmHistoriesu:false,
      loadingDialog: false,
      application: [],
      newCheckList: [],
      checkList: [],
      needCorrections: [
        "- 提供影像清晰的證件相片 Provide a clear passport photo",
        "- 上載香港出生證明書 Upload Hong Kong Birth Certificate",
        "- 上載香港身份證 Upload Hong Kong Identity Card",
        "- 上載護照(載有個人資料及相片頁) Upload Passport (include pages showing personal data and photo)",
        "- 上載香港入境處發出的逗留期限簽證/入境許可紙) Upload Immigration Endorsement showing the expiry date of visa/entry permit",
        "- 上載最近三年成績表 Upload Academic Reports of the recent three years",
      ],
      operationTypes: 0,
      text: "",
      formInline: {
        newStatus: "",
      },
      tabs: [
        {
          label: "Applicant Detail",
          name: "first",
          type: 0,
        },
        {
          label: "Supporting Document",
          name: "second",
          type: 1,
        },
        {
          label: "Payment Detail",
          name: "third",
          type: 2,
        },
        {
          label: "Other Question",
          name: "fourth",
          type: 3,
        },
        {
          label: "Subject Applied",
          name: "five",
          type: 4,
        },
        {
          label: "Status History",
          name: "six",
          type: 5,
        },
      ],
      activeName: "first",
      applicationDetail: {
        registrationNo: "",
        applicantName: "",
        applicant: {
          id: 0,
          email: "",
          password: "",
          status: 0,
          roleId: 0,
        },
        applicationDate: "",
        formType: 0,
        eventStatus: {
          id: 0,
          title: "",
          type: 0,
          startDate: "",
          endDate: "",
          isExpired: true,
          applicationNode: "",
          registrationNo: "",
        },
        stage: 0,
        status: 0,
        applyAt: "",
        lastUpdateAt: "",
        receiptFile: "",
        payType: 0,
        paidAt: "",
        paymentId: "",
        components: [
          {
            type: 0,
            value: "",
          },
        ],
        statusHistories: [
          {
            operationType: 0,
            officeStaff: "",
            oldStatus: 0,
            newStatus: 0,
            changeTime: "",
          },
        ],
        confirmHistories: [
          
        ],
      },
      confirmCenterDialogVisible: false,
      needCorrectionCenterDialogVisible: false,
    };
  },
  created() {
    this.getApplicationDetail();
    this.getApplication()
  },
  watch: {
    activeName :{
      handler(v){
      if (v != null) {
        if (v == "first") {
          this.operationTypes = 0;
        } else if (v == "second") {
          this.operationTypes = 1;
        } else if (v == "third") {
          this.operationTypes = 2;
        }  else if (v == "fourth") {
          this.operationTypes = 3;
        } else if (v == "five") {
          this.operationTypes = 4;
        }
      }
      },
      deep: true,
      immediate: true
    },
  },
  computed:{
    applicationIndex(){
      //寻找当前元素的数组下标
      return this.application.findIndex(element => element === this.id)
    }
  },
  methods: {
    onPrevious(){
      let intr = this.applicationIndex
      intr--;
      this.$router.push({name:"adminApplicationDetail", params:{id:this.application[intr],type:this.type}});
      this.getApplicationDetail()
    },
    onNext(){
      let intr = this.applicationIndex
      intr++;
      this.$router.push({name:"adminApplicationDetail", params:{id:this.application[intr],type:this.type}});
      this.getApplicationDetail()
    },
    isOperationType() {
      //判断数组对象是否包含特定值
      let isContain = this.applicationDetail.confirmHistories.some((item) => {
        return item.operationType == this.operationTypes;
      });
      return isContain;
    },
    close() {
      this.needCorrectionCenterDialogVisible = false;
    },
    onSave(status, type) {
      this.addBatchChangeApplicationFormsStatus(status, type);
    },
    getConfirmApplicationHistories(type) {
      let isConfirm = false;
      let filterHistories = this.applicationDetail?.confirmHistories.filter(
        (v) => {
          return v.operationType == type;
        }
      );
      if (filterHistories.length > 0) {
        isConfirm = true;
      }
      return isConfirm;
    },
    onConfirmNeed() {
      this.loadingDialog = true;
      this.newCheckList = [];
      this.newCheckList.push(...this.checkList);
      if (this.text != "") {
        this.text = "- 其他  Others: " + this.text;
        this.newCheckList.push(this.text);
      }
      this.addRequestsFromApplications();
    },
    onCancelNeed() {
      this.needCorrectionCenterDialogVisible = false;
    },
    onNeedCorrection() {
      this.needCorrectionCenterDialogVisible = true;
    },
    onConfirm() {
      this.addBatchChangeApplicationFormsStatus(5, 3);
    },
    onCancel() {
      this.confirmCenterDialogVisible = false;
    },
    onConfirmApplication() {
      if (this.isConfirmHistories()) {
        this.addBatchChangeApplicationFormsStatus(5, 3);
      } else {
        this.$message.error(
          "You should confirm applicant detail，supporting document and payment detail before confirm the application."
        );
      }
    },
    onConfirmApplicationDetail() {
      this.confirmRequest();
    },
    confirmRequest() {
      let from = {
        operationType: this.operationTypes,
      };
      confirmRequest(this.id, from).then(() => {
        this.getApplicationDetail();
      });
    },
    addBatchChangeApplicationFormsStatus(status, type) {
      let from = {
        applicationFormIds: [this.id],
        newStatus: status,
        sendType: type,
        formType: this.applicationDetail.formType,
      };
      addBatchChangeApplicationFormsStatus(from)
        .then(() => {
          this.$message.success("Set successfully.");
        })
        .finally(() => {
          this.confirmCenterDialogVisible = false;
        });
    },
    addRequestsFromApplications() {
      let from = [...this.newCheckList];
      addRequestsFromApplications(this.id, from)
        .then(() => {})
        .finally(() => {
          this.checkList = [];
          this.newCheckList = [];
          this.text = "";
          this.needCorrectionCenterDialogVisible = false;
          this.loadingDialog = false;
        });
    },
    getApplication() {
      let from = {
        formType: this.type,
        _page: 0,
        _limit: this.total,
      };
      getApplication(from).then((v) => {
        this.application = v.data.map((k)=>{
           return k.id
        });
      });
    },
    getApplicationDetail() {
       this.loading = true
      getApplicationDetail(this.id).then((v) => {
        this.applicationDetail = v.data;
        this.loading = false
      });
    },
    isConfirmHistories(){
      if(this.isNoMsType()&&this.applicationDetail.confirmHistories.length == 3){
        this.isConfirmHistoriesu = true
      }
      if(this.isMsType()&&this.applicationDetail.confirmHistories.length == 5){
        this.isConfirmHistoriesu = true
      }
      return this.isConfirmHistoriesu
    },
    isNoMsType(){
      if(this.type !==5 && this.type !== 4  && this.type !== 11){
        return true
      }else {
        return false
      }
    },
    isMsType(){
      if(this.type ==5 || this.type == 4  || this.type == 11){
        return true
      }else {
        return false
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-title-box{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.page-box {
  background-color: #fff;
  margin-bottom: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
}
.page-box-title {
  display: flex;
  border-bottom: 1px solid #707070;
  justify-content: space-between;
  padding: 0 47px;
  padding-top: 46px;
  padding-bottom: 27px;
}
.search-box {
  padding-top: 50px;
  padding-bottom: 40px;
  padding-left: 50px;
  padding-right: 50px;
}
.dialog-text {
  font-size: 36px;
  color: #272727;
}
.dialog-d {
  font-size: 20px;
}
.page-warning-button {
  margin-left: auto;
}
.page-box-button {
  padding: 0 10px;
  text-align: right;
}
.input-text-others {
  text-align: left;
  font-size: 16px;
  margin-top: 16px;
}
.page-row {
  padding: 20px;
}
.checkedPrimary {
  background-color: #aaaaaa;
  border-color: #aaaaaa;
}
::v-deep {
  .el-checkbox-group {
    display: flex;
    flex-direction: column;
    justify-items: flex-start;
    align-items: flex-start;
    width: 100%;
  }
  .el-checkbox {
    display: flex;
    width: 100%;
    margin-top: 15px;
  }
  .el-checkbox__label {
    width: 100%;
    display: block;
    font-size: 16px;
    text-align: left;
    overflow: hidden;
    font-weight: 400;
    white-space: break-spaces;
    word-wrap: break-word;
    word-break: break-word;
  }
  .el-button--warning.is-disabled:hover {
    background-color: #aaaaaa;
    border-color: #aaaaaa;
  }
}
</style>